import React, { Component } from 'react'
import { CUSTOM_CHANNEL, INBOX_TYPES } from '@disco/constants/GroupTypes'
import { sendTrackDownloadEventThrottled } from '@disco/utils/eventsApi'
import GroupModal from 'components/common/custom-libraries/edit-form'
type Props = {
  track: Record<string, any>
  sourceGroup?: Record<string, any>
  sourcePlaylistId?: number
  onClose: (...args: Array<any>) => any
  addTrackToGroups: (...args: Array<any>) => any
  updateGroup: (...args: Array<any>) => any
  createGroup: (...args: Array<any>) => any
  user: Record<string, any>
  sendMixpanelEvent: (...args: Array<any>) => any
}
export default class AddToNewChannelModal extends Component<Props> {
  _onCreateGroup: (name: string, group: any) => void = (
    name: string,
    group: Record<string, any>,
  ) => {
    if (group) this.props.addTrackToGroups(this.props.track, [group])
    this.props.sendMixpanelEvent('Add to new channel from track menu')

    if (
      this.props.sourceGroup &&
      INBOX_TYPES.includes(this.props.sourceGroup.group_type)
    ) {
      sendTrackDownloadEventThrottled(this.props.track.id, 'in-app', {
        group_id: this.props.sourceGroup.id,
        playlist_id: this.props.sourcePlaylistId,
      })
    }

    this.props.onClose()
  }

  render(): React.ReactNode {
    return (
      <GroupModal
        updateGroup={this.props.updateGroup}
        createGroup={this.props.createGroup}
        user={this.props.user}
        groupType={CUSTOM_CHANNEL}
        onSubmit={this._onCreateGroup}
        onClose={this.props.onClose}
      />
    )
  }
}
